import { useEffect, useState } from 'react';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

interface PushNotificationHook {
  getPushNotificationToken: () => Promise<string | null>;
  tokenFound: boolean;
  currentNotificationToken: string;
  getMessage: (callback: (payload: any) => void) => void;
  checkAndRequestNotificationPermission: () => Promise<boolean>;
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FCM_API_KEY,
  authDomain: process.env.REACT_APP_FCM_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FCM_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FCM_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FCM_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FCM_APP_ID,
  measurementId: process.env.REACT_APP_FCM_MESUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const usePushNotifications = (): PushNotificationHook => {
  const [tokenFound, setTokenFound] = useState<boolean>(false);
  const [currentNotificationToken, setCurrentNotificationToken] =
    useState<string>('');
  const publicKey = process.env.REACT_APP_FCM_VAPID_KEY;
  const getPushNotificationToken = async (): Promise<string | null> => {
    try {
      const currentToken = await getToken(messaging, { vapidKey: publicKey });
      if (currentToken) {
        setCurrentNotificationToken(currentToken);
        setTokenFound(true);
        return currentToken;
      } else {
        setTokenFound(false);
        return null;
      }
    } catch (error) {
      return null;
    }
  };
  const getMessage = (callback: (payload: any) => void): void => {
    onMessage(messaging, payload => {
      callback(payload);
    });
    // You may want to return unregister if you want to unregister the message listener later
  };

  const checkAndRequestNotificationPermission = async (): Promise<boolean> => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        return true;
      } else {
        sessionStorage.removeItem('notificationTokenSent');
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  const handlePermission = async () => {
    try {
      const permissionGranted = await checkAndRequestNotificationPermission();
      if (permissionGranted) {
        retrieveToken();
      }
    } catch (error) {
      console.error('Error while handling permission:', error);
    }
  };
  const retrieveToken = async () => {
    try {
      const token = await getPushNotificationToken();
      if (token) console.log(token, 'token');
    } catch (error) {
      console.error('Error while retrieving token:', error);
    }
  };

  useEffect(() => {
    handlePermission();
  }, []);

  return {
    getPushNotificationToken,
    tokenFound,
    currentNotificationToken,
    getMessage,
    checkAndRequestNotificationPermission,
  };
};

export default usePushNotifications;
